import React, { useEffect } from "react";
import { useAssessment } from "providers/Assessment";
import useAssessmentReportEnabled from "apps/user/learner/hooks/use-assessment-report-enabled";
import AssessmentCalculatingUplift from "./AssessmentCalculatingUplift";

const AssessmentInterstitialAnimation = () => {
  const { onSubmit } = useAssessment();
  const { enabled: reportEnabled, resolved } = useAssessmentReportEnabled();

  useEffect(() => {
    onSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Withheld only until the answer is known, not until the request settles.
  // The learner reaches this screen from the assessment, where the flags were
  // already read, so in the real journey the answer is here on the first
  // render and the backdrop never changes under them.
  return <AssessmentCalculatingUplift showSky={resolved && reportEnabled} />;
};

export default AssessmentInterstitialAnimation;
